import { Header } from "@/components/layout/Header";
import React from "react";

const Footer = () => (
  <footer className="bg-gray-900 text-white py-12 mt-20">
    <div className="container px-4 mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0">
          <h2 className="text-xl font-bold">Openstudio</h2>
          <p className="text-gray-400 mt-2">Oživte prázdné prostory s Openstudio</p>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          <div>
            <h3 className="text-lg font-medium mb-2">Služby</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">Virtuální zařízení</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Interiérový design</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Realitní služby</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-medium mb-2">Společnost</h3>
            <ul className="space-y-2">
              <li><a href="/kontakt" className="text-gray-400 hover:text-white">Kontakt</a></li>
              <li><a href="/ochrana-osobnich-udaju" className="text-gray-400 hover:text-white">Ochrana osobních údajů</a></li>
              <li><a href="/obchodni-podminky" className="text-gray-400 hover:text-white">Všeobecné obchodní podmínky</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-12 pt-6 text-center">
        <p className="text-gray-400">© {new Date().getFullYear()} Openstudio. Všechna práva vyhrazena.</p>
      </div>
    </div>
  </footer>
);

const ObchodniPodminky = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1 flex flex-col items-center justify-center py-20">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-bold mb-8">Všeobecné obchodní podmínky</h1>
        <div className="text-lg text-gray-800 space-y-6 whitespace-pre-line">
1. Úvodní ustanovení
1.1 Tyto všeobecné obchodní podmínky (dále jen „VOP“) stanovují podmínky používání a nákupu produktů a služeb na webu OpenStudio.cz.

1.2 Používání webu OpenStudio.cz a nákup produktů a služeb prostřednictvím tohoto webu je podmíněno akceptací a dodržováním těchto VOP.

2. Objednávka a platba
2.1 Objednávka produktů a služeb na webu OpenStudio.cz je považována za nabídku k uzavření smlouvy o nákupu.

2.2 Plnění objednávky je podmíněno úspěšným provedením platby v souladu s platnými cenami uvedenými na webu OpenStudio.cz.

2.3 OpenStudio.cz si vyhrazuje právo odmítnout objednávku z jakéhokoli důvodu a bez udání příčiny.

3. Doprava a dodání
3.1 Doprava produktů je prováděna prostřednictvím společností dodávek a doručení, které jsou partnerem OpenStudio.cz.

3.2 Datum dodání produktů je orientační a může být ovlivněno různými faktory, jako jsou dostupnost produktů, geografická poloha a další okolnosti.

4. Vrácení zboží a reklamace
4.1 Zákazník má právo na vrácení zboží a reklamaci v souladu s platnými zákony a předpisy.

4.2 Vrácení zboží a reklamace jsou přijímány pouze v souladu s podmínkami uvedenými na webu OpenStudio.cz.

5. Omezení odpovědnosti
5.1 OpenStudio.cz nenese odpovědnost za škody způsobené užíváním produktů a služeb zakoupených na webu OpenStudio.cz, pokud není prokázáno zavinění nebo hrubá nedbalost ze strany OpenStudio.cz.

6. Ochrana osobních údajů
6.1 Ochrana osobních údajů zákazníků je podrobně popsána v dokumentu Ochrana osobních údajů, který je dostupný na webu OpenStudio.cz.

7. Změny ve všeobecných obchodních podmínkách
7.1 OpenStudio.cz si vyhrazuje právo kdykoli změnit nebo aktualizovat tyto VOP. Změny vstupují v platnost okamžikem zveřejnění na webu OpenStudio.cz.

8. Kontaktní informace
8.1 Pro jakékoli dotazy, požadavky nebo stížnosti týkající se těchto VOP, prosím, kontaktujte nás na následujících kontaktech:

E-mail: info@openstudio.cz

Adresa: OpenStudio.cz, Hlavní 123, 100 00 Praha

9. Platnost dokumentu
9.1 Tyto VOP jsou platné od 18. března 2024 a nahrazují veškeré předchozí verze.
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default ObchodniPodminky; 